export const getAuthToken = () =>
  sessionStorage.getItem("token") || localStorage.getItem("token");

export const setAuthToken = (token) => {
  sessionStorage.setItem("token", token);
  localStorage.setItem("token", token);
};

export const getRefreshToken = () =>
  sessionStorage.getItem("refresh") || localStorage.getItem("refresh");

export const setRefreshToken = (refresh) => {
  sessionStorage.setItem("refresh", refresh);
  localStorage.setItem("refresh", refresh);
};

export const isUserLoggedIn = () => {
  return !!getAuthToken();
};

export  const getMicrositeUrl = (partnerName) => {
  const baseUrl = process.env.REACT_APP_MICROSITE_BASE_URL;
  if (!baseUrl) return "";

  // Local / Dev → no subdomain
  if (baseUrl.includes("localhost") || baseUrl.includes("web.core.windows.net")) {
    return baseUrl.startsWith("http") ? baseUrl : `https://${baseUrl}`;
  }

  // Prod → dynamic subdomain
  // Convert partner name to URL-safe format
  const safePartner = partnerName.toLowerCase().replace(/\s+/g, "-");
  return `https://${safePartner}.${baseUrl}`;
};